import React from "react";
import { modalOverrides, sponsorModal, textModal } from "./common";
export default [
    {
        width: "4.8%",
        height: "10%",
        left: "70%",
        top: "5.4%",
        label: "CybelAngel - Chat with us",
        isExternal: true,
        modalOverrides: textModal("fit-content"),
        modal: React.createElement(React.Fragment, null,
            React.createElement("h1", null, "The chat feature is now closed."),
            React.createElement("p", null, "Please contact sponsors using the contact forms."))
    },
    {
        width: "5.8%",
        height: "7%",
        left: "59%",
        top: "17%",
        label: "CybelAngel - Play Content",
        isExternal: true,
        modalOverrides: modalOverrides,
        modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
            React.createElement("iframe", { width: "100%", height: "100%", frameBorder: "0", src: "https://player.vimeo.com/video/768634608?h=f8b7f81796&autoplay=1", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }))
    },
    {
        width: "5%",
        height: "11%",
        left: "65%",
        top: "23.4%",
        label: "CybelAngel - Download Content",
        isExternal: true,
        target: "_blank",
        href: "https://assets.swoogo.com/uploads/2182081-636a73de55f89.pdf"
    },
    {
        width: "13.8%",
        height: "7%",
        left: "55%",
        top: "9%",
        label: "CybelAngel - Social Media",
        isExternal: true,
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 3", "CybelAngel", React.createElement(React.Fragment, null, "CybelAngel is a global leader in External Attack Surface Management (EASM) and Digital Risk Protection (DRP) cybersecurity solutions. Using the most comprehensive asset discovery methodologies and external attack surface search techniques available, CybelAngel scans the entirety of the Internet every 24 hours to find hidden assets such as leaked data, open ports, file servers, databases, cloud buckets, shadow IT, malicious domains, devices, and more. Applying close to a decade of machine learning activity and a team of experienced cyber analysts, CybelAngel EASM is the only solution that can detect, assess, monitor and remediate, vulnerable attack surfaces (the open doors) and exposed information (the keys) \u2014 going deep into servers to uncover sensitive and confidential data where it should not be. To join the hundreds of organisations world-wide that trust CybelAngel to help them pre-empt data breaches by keeping their data, information, assets, and attack surfaces safe from the outside-in, visit:"), {
            twitter: "https://twitter.com/CybelAngel",
            linkedin: "https://www.linkedin.com/company/cybelangel",
            company: "https://cybelangel.com/"
        })
    }
];
